export const actions = {
  CREATE: 'quizLitmos/create',
  UPDATE: 'quizLitmos/update',
  CLEAR: 'quizLitmos/clear',
  SET_UNIQUE_ANSWER: 'quizLitmos/set-unique-answer',
  SET_SELECTED: 'quizLitmos/set-selected',
  SET_DISPLAYED_EDIT: 'quizLitmos/set-displayed-edit',
  SET_ANSWER: 'quizLitmos/setAnswer',
  CLEAR_SELECTED_ANSWER: 'quizLitmos/clearSelectedAnswer',
};

type Selected = unknown[];

interface Answer {
  index: number;
  value: unknown;
  slideType: string;
  key: string;
}

interface QuizAction {
  type:
    | typeof actions.CREATE
    | typeof actions.UPDATE
    | typeof actions.CLEAR
    | typeof actions.SET_UNIQUE_ANSWER
    | typeof actions.SET_SELECTED
    | typeof actions.SET_DISPLAYED_EDIT
    | typeof actions.SET_ANSWER
    | typeof actions.CLEAR_SELECTED_ANSWER;
  payload: Quiz | Answer;
}

export const create = (payload: Quiz) => {
  return {
    type: actions.CREATE,
    payload,
  };
};

export const update = (payload: Quiz) => {
  return {
    type: actions.UPDATE,
    payload,
  };
};

export const clear = () => {
  return {
    type: actions.CLEAR,
  };
};

export const setUniqueAnswer = (value: string, key: string) => {
  return {
    type: actions.SET_UNIQUE_ANSWER,
    payload: {
      value,
      key,
    },
  };
};

export const setSelected = (selected: Selected) => {
  return {
    type: actions.SET_SELECTED,
    payload: {
      selected,
    },
  };
};

export const setDisplayedEdit = (displayedEditId: string) => {
  return {
    type: actions.SET_DISPLAYED_EDIT,
    payload: {
      displayedEditId,
    },
  };
};

export const setAnswer = (selectedAnswer: Answer) => {
  return {
    type: actions.SET_ANSWER,
    payload: {
      selectedAnswer,
    },
  };
};

export const clearSelectedAnswer = () => {
  return {
    type: actions.CLEAR_SELECTED_ANSWER,
  };
};

export const initialState: Quiz = {
  advance: false,
  choicesShouldPulse: false,
  disableNext: true,
  displayedEditId: '',
  explanationButtonsShouldPulse: false,
  outOfTries: false,
  selected: [],
  selectedAnswer: undefined,
  showCollapsiblePanel: true,
  showSubmit: false,
  showTries: false,
  tooltipEngaged: false,
  tries: 0,
};

export const quizLitmosReducer = (state = initialState, action: QuizAction): Quiz => {
  switch (action.type) {
    case actions.CREATE:
      return action.payload as Quiz;
    case actions.UPDATE:
      return {
        ...state,
        ...action.payload,
      };
    case actions.SET_UNIQUE_ANSWER: {
      const payload: Answer = action.payload as Answer;
      return {
        ...state,
        [payload.key]: payload.value,
      };
    }
    case actions.SET_SELECTED: {
      const payload: Quiz = action.payload as Quiz;
      return {
        ...state,
        selected: payload.selected,
      };
    }
    case actions.SET_DISPLAYED_EDIT: {
      const payload: Quiz = action.payload as Quiz;
      return {
        ...state,
        displayedEditId: payload.displayedEditId,
      };
    }
    case actions.SET_ANSWER:
      const payload: Quiz = action.payload as Quiz;
      return {
        ...state,
        selectedAnswer: payload.selectedAnswer,
      };
    case actions.CLEAR_SELECTED_ANSWER:
      return {
        ...state,
        selectedAnswer: initialState.selectedAnswer,
      };
    case actions.CLEAR:
      return initialState;
    default:
      return state;
  }
};
